import React, {useState} from "react";
import Rating from '@material-ui/lab/Rating';
import {withRouter} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import i18n from "../../../i18nextInitiator";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import ButtonWithLoading from "../ButtonWithLoading";
import {connect} from "react-redux";
import {checkComment, warningAlert} from "../../../actions/actionCreators";
import ProviderInfo from "../Tracker/ProviderInfo/ProviderInfo";
import {compose} from "redux";
import TrackerHoc from "../Tracker/TrackerHoc";
import {rateOrder} from "../../../actions/apiCallActions";

/**
 * The translate function
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * Styles
 * @type {(props?: any) => ClassNameMap<"root">}
 */
const useStyles = makeStyles((theme) => ({
    root: {
        padding: "0 20px",
        maxWidth: 600,
        margin: "0 auto",
        justifyContent: "center",
        '& > *': {
            margin: "2rem 0",
        },
        '& button': {
            boxShadow: "unset"
        },
        '& textarea': {
            boxShadow: "unset",
            borderRadius: "unset"
        },
    },
    rating: {
        fontSize: "2.5rem",
        padding: "1rem 0"
    },
    pointsBox: {
        width: "100%",
        [theme.breakpoints.down("xs")]: {
            '& .MuiTypography-body1': {
                fontSize: ".9rem"
            },
        }
    },
    strengthItems: {
        color: theme.palette.success.main,
        '&$checked': {}
    },
    weakItems: {
        color: theme.palette.error.main,
        "&$checked": {}
    }
}));

/**
 * maps redux states to component props.
 * @param state
 */
const mapStateToProps = state => ({...state});

const Comment = (props) => {
    const classes = useStyles();
    const id = props.match.params.id;
    const [stars, setStars] = React.useState(0);
    const [comment, setComment] = React.useState("");
    const [points, setPoints] = React.useState({});
    const [strengthPoints, setStrengthPoints] = useState(Array(3).fill("rating.comments.strength"));
    const [weakPoints, setWeakPoints] = useState(Array(4).fill("rating.comments.weakness"));

    React.useEffect(() => {
        checkComment(id);
    }, [])

    /**
     * Triggers on changing checkboxes.
     * @param event
     */
    const pointItemChanged = event => {
        let rival = t(`${weakPoints[0]}.${event.target.value}`);
        rival = rival !== event.target.name ? rival : t(`${strengthPoints[0]}.${event.target.value}`);
        setPoints({...points, [event.target.name]: event.target.checked, [rival]: false})
    };

    const send = () => {
        if (!props.invoice.rate) {
            warningAlert(t('rating.no-stars-warning'))
            return null;
        }
        let allPoints = '';
        Object.keys(points).forEach(key => {
            if (points[key])
                allPoints += key + "، "
        })
        const cm = allPoints + comment;
        rateOrder(cm);
    };

    /**
     * Items component to show the selecting comment items.
     * @param props
     * @return {JSX.Element}
     * @constructor
     */
    const Items = props => {
        return <Grid item xs={6}>
            <FormGroup>
                {props.data.map((name, index) => {
                    const title = t(`${name}.${index}`);
                    const checked = points[title] ?? false;
                    return <FormControlLabel
                        key={index}
                        label={title}
                        control={<Checkbox
                            className={props.styleClass}
                            key={index}
                            color={"default"}
                            onChange={pointItemChanged}
                            name={title}
                            value={index}
                            checked={checked}/>}
                    />
                })}
            </FormGroup>
        </Grid>
    };

    return <div className={classes.root}>
        <Grid container justifyContent={"center"}>
            <Typography component={"legend"} variant={"h6"} align={"center"} gutterBottom>
                {t('rating.title')}
            </Typography>

            <ProviderInfo {...props} commentPage />

        </Grid>
        <Grid>
            <Typography component={"legend"} variant={"h6"} align={"center"}>
                {t('rating.items-title')}
            </Typography>
            <FormControl className={classes.pointsBox}>
                <Grid container justifyContent={"space-between"}>
                    <Items data={strengthPoints} styleClass={classes.strengthItems}/>
                    <Items data={weakPoints} styleClass={classes.weakItems}/>
                </Grid>
            </FormControl>
            <TextField
                multiline fullWidth rows={4}
                variant="outlined"
                label={t("more-desc")}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
            />
        </Grid>
        <ButtonWithLoading loading={props.invoice.sendingComment} action={send}
                           text={`${t('submit')} ${t('rating.comment')}`}/>
    </div>
};
export default compose(withRouter, connect(mapStateToProps), TrackerHoc)(Comment);